export default {
    'profile.pastJobs': {
        handler: function(pastJobs) {
            const self = this
            pastJobs.forEach((pastJob) => {
                self.$parent.setJobFormattedDates(pastJob)
            })
        },
        deep: true
    }
}
